export default __webpack_public_path__ + "static/media/logoLMS.9c75300f.png";